import React, { useState, useEffect, useContext, Component } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { authActions } from '../../redux/store';
import { toast } from 'react-hot-toast';
import Header from '../components/Header';
import Footer from '../components/Footer';
import NavBar from '../components/NavBar';
import HeaderPage from '../components/HeaderPage';

const ErrorPage = () => {

  return (
    <>

      <HeaderPage title={'Not Found'} />

      <main className="page-content  mypadding bg-light overflow-auto pb-4" >


        <div className="d-flex align-items-center justify-content-center vh-100 bg-white">
          <div className="text-center row">

            <div className=" col-md-12 mt-0">

              <p className="fs-3">
                {" "}
                <span className="text-danger">Opps!</span> Page not found.
              </p>
              <p className="lead">The page you’re looking for doesn’t exist.</p>
              <Link to="/" className="btn btn-primary">
                Go Home
              </Link>
            </div>
          </div>
        </div>

        <NavBar />

      </main>
    </>

  );
};

export default ErrorPage